export const USER_INFO_FEATURE_NAME = 'user-info';
